export const thankYouPageDict = {
  en: {
    label: 'Last step',
    heading:
      '<b>Which method of obtaining a residence permit or a second citizenship</b> are you primarily interested in?',
    confirmEmailStepsTitle: 'Follow the link from an email',
    confirmEmailStepsDescription: '',
    confirmEmailStepsButtonTitle: 'OPEN GMAIL',
    confirmEmailSteps: [
      'Go to your inbox',
      'Open an email from us',
      'Follow the link from the email',
    ],
    surveyTitle: 'Choose a Way to Obtain Residency or Second Citizenship',
    surveyDescription:
      'You can become a resident of another country through investments, proof of financial stability, or employment. ✔️ Indicate which option suits you best.',
  },
  ru: {
    label: 'Последний шаг',
    heading:
      '<b>Какой способ получения ВНЖ или второго гражданства</b> вас интересует в первую очередь?',
    confirmEmailStepsTitle: 'Перейдите по ссылке из письма',
    confirmEmailStepsDescription: '',
    confirmEmailStepsButtonTitle: 'ОТКРЫТЬ GMAIL',
    confirmEmailSteps: [
      'Зайдите на почту',
      'Откройте письмо от нас',
      'Перейдите по ссылке в письме',
    ],
    surveyTitle: 'Выберите способ получения ВНЖ или второго гражданства',
    surveyDescription:
      'Стать резидентом другой страны можно через инвестиции, подтверждение финансовой состоятельности или трудоустройство. ✔️ Укажите, какой вариант подходит вам больше остальных.',
  },
  de: {
    label: 'Letzter Schritt',
    heading:
      '<b>An welcher Methode zur Erlangung einer Aufenthaltsgenehmigung oder einer zweiten Staatsbürgerschaft</b> sind Sie hauptsächlich interessiert?',
    confirmEmailStepsTitle: 'Folgen Sie dem link aus einer E-Mail',
    confirmEmailStepsDescription: '',
    confirmEmailStepsButtonTitle: 'GMAIL ÖFFNEN',
    confirmEmailSteps: [
      'Gehen Sie zu Ihrem Posteingang',
      'Öffnen Sie eine E-Mail von uns',
      'Folgen Sie dem link aus der E-Mail',
    ],
    surveyTitle:
      'Wählen Sie einen Weg zur Erlangung einer Aufenthaltsgenehmigung oder zweiten Staatsbürgerschaft',
    surveyDescription:
      'Sie können durch Investitionen, Nachweis finanzieller Stabilität oder Beschäftigung Einwohner eines anderen Landes werden. ✔️ Geben Sie an, welche Option am besten zu Ihnen passt.',
  },
  tr: {
    label: 'Son adım',
    heading:
      '<b>Hangi yöntemle oturma izni veya ikinci vatandaşlık</b> almak istiyorsunuz?',
    confirmEmailStepsTitle: 'E-postadan bağlantıyı takip edin',
    confirmEmailStepsDescription: '',
    confirmEmailStepsButtonTitle: 'GMAIL AÇ',
    confirmEmailSteps: [
      'E-posta kutunuza gidin',
      'Bizden gelen e-postayı açın',
      'E-postadaki bağlantıyı takip edin',
    ],
    surveyTitle: 'İkametgah veya İkinci Vatandaşlık Almanın Yollarını Seçin',
    surveyDescription:
      'Yatırımlar, mali yeterlilik kanıtı veya istihdam yoluyla başka bir ülkede ikamet edebilirsiniz. ✔️ Hangi seçeneğin size en uygun olduğunu belirtin.',
  },
  es: {
    label: 'Último paso',
    heading:
      '<b>¿Qué método de obtención de un permiso de residencia o una segunda ciudadanía</b> le interesa principalmente?',
    confirmEmailStepsTitle: 'Siga el enlace del correo electrónico',
    confirmEmailStepsDescription: '',
    confirmEmailStepsButtonTitle: 'ABRIR GMAIL',
    confirmEmailSteps: [
      'Vaya a su bandeja de entrada',
      'Abra un correo electrónico nuestro',
      'Siga el enlace del correo electrónico',
    ],
    surveyTitle: 'Elija una forma de obtener residencia o segunda ciudadanía',
    surveyDescription:
      'Puede convertirse en residente de otro país a través de inversiones, prueba de estabilidad financiera o empleo. ✔️ Indique qué opción le conviene más.',
  },
};

export const thankYouInvestmentPageDict = {
  ru: {
    answers: [
      {
        id: 'invest',
        title: 'Инвестиции',
        description:
          'Готов выполнить инвестиционные условия, чтобы получить ВНЖ или второй паспорт. Например, купить недвижимость, открыть бизнес или депозит в банке.',
        icon: '/images/icons/investment.svg',
        userAnswer: 'Investments',
      },
      {
        id: 'job',
        title: 'Трудоустройство',
        description:
          'Хочу найти работу за границей, на основании этого переехать, и в последующем получить гражданство.',
        icon: '/images/icons/employment.svg',
        userAnswer: 'Employment',
      },
    ],
  },
  de: {
    answers: [
      {
        id: 'invest',
        title: 'Investitionen',
        description:
          'Bereit, Gelder zu investieren, um eine Staatsbürgerschaft oder eine Aufenthaltsgenehmigung ohne Aufenthaltspflicht und andere Verpflichtungen zu erhalten.',
        icon: '/images/icons/investment.svg',
        userAnswer: 'Investments',
      },
      {
        id: 'job',
        title: 'Beschäftigung',
        description:
          'Ich möchte einen Job in Europa finden und auf dieser Grundlage umziehen und anschließend die Staatsbürgerschaft erhalten.',
        icon: '/images/icons/employment.svg',
        userAnswer: 'Employment',
      },
    ],
  },
  en: {
    answers: [
      {
        id: 'invest',
        title: 'Investments',
        description:
          'Ready to invest funds to obtain citizenship or a residence permit without obligations of residence and others.',
        icon: '/images/icons/investment.svg',
        userAnswer: 'Investments',
      },
      {
        id: 'job',
        title: 'Employment',
        description:
          'I want to find a job in Europe and, on the basis of this, move, and subsequently obtain citizenship.',
        icon: '/images/icons/employment.svg',
        userAnswer: 'Employment',
      },
    ],
  },
  tr: {
    answers: [
      {
        id: 'invest',
        title: 'Yatırımlar',
        description:
          'Vatandaşlık veya oturma izni almak için yatırım yapmaya hazırım. Örneğin, emlak almak, iş kurmak veya bankada mevduat yapmak.',
        icon: '/images/icons/investment.svg',
        userAnswer: 'Investments',
      },
      {
        id: 'job',
        title: 'İstihdam',
        description:
          'Avrupa’da iş bulmak istiyorum ve bunun üzerinden taşınarak, sonrasında vatandaşlık almayı planlıyorum.',
        icon: '/images/icons/employment.svg',
        userAnswer: 'Employment',
      },
    ],
  },
  es: {
    answers: [
      {
        id: 'invest',
        title: 'Inversiones',
        description:
          'Listo para invertir fondos para obtener ciudadanía o un permiso de residencia sin obligaciones de residencia y otras.',
        icon: '/images/icons/investment.svg',
        userAnswer: 'Investments',
      },
      {
        id: 'job',
        title: 'Empleo',
        description:
          'Quiero encontrar trabajo en Europa y, sobre esta base, mudarme y posteriormente obtener la ciudadanía.',
        icon: '/images/icons/employment.svg',
        userAnswer: 'Employment',
      },
    ],
  },
};

export const thankYouDigitalNomadPageDict = {
  ru: {
    answers: [
      {
        id: 'regular-income',
        title: 'Подтвердить регулярный доход',
        description:
          'Получаю доход от 2000 € в месяц и работаю дистанционно. Планирую переехать за границу как цифровой кочевник.',
        href: '/#regular-income',
        icon: '/images/icons/regular-income.svg',
        userAnswer: 'Confirm regular income',
      },
      {
        id: 'family-ties',
        title: 'Доказать родственные связи',
        description:
          'Хочу получить ВНЖ через воссоединение семьи — и переехать к родственникам, супруге или супругу.',
        icon: '/images/icons/family-ties.svg',
        userAnswer: 'Prove family ties',
      },
    ],
  },
  en: {
    answers: [
      {
        id: 'regular-income',
        title: 'Confirm regular income',
        description:
          'I earn €2000 per month and work remotely. I plan to move abroad as a digital nomad.',
        icon: '/images/icons/regular-income.svg',
        userAnswer: 'Confirm regular income',
      },
      {
        id: 'family-ties',
        title: 'Prove family ties',
        description:
          'I want to obtain a residence permit through family reunification and move to live with relatives, a spouse, or a partner.',
        href: '/#family-ties',
        icon: '/images/icons/family-ties.svg',
        userAnswer: 'Prove family ties',
      },
    ],
  },
  de: {
    answers: [
      {
        id: 'regular-income',
        title: 'Regelmäßiges Einkommen bestätigen',
        description:
          'Ich verdiene 2000 € pro Monat und arbeite remote. Ich plane, als digitaler Nomade ins Ausland zu ziehen.',
        icon: '/images/icons/regular-income.svg',
        userAnswer: 'Confirm regular income',
      },
      {
        id: 'family-ties',
        title: 'Familiäre Bindungen nachweisen',
        description:
          'Ich möchte eine Aufenthaltsgenehmigung durch Familienzusammenführung erhalten und zu Verwandten, einem Ehepartner oder einem Lebenspartner ziehen.',
        icon: '/images/icons/family-ties.svg',
        userAnswer: 'Prove family ties',
      },
    ],
  },
  tr: {
    answers: [
      {
        id: 'regular-income',
        title: 'Düzenli gelirimi onaylayın',
        description:
          'Aylık 2000 € gelir elde ediyorum ve uzaktan çalışıyorum. Dijital göçebe olarak yurtdışına taşınmayı planlıyorum.',
        icon: '/images/icons/regular-income.svg',
        userAnswer: 'Confirm regular income',
      },
      {
        id: 'family-ties',
        title: 'Aile bağlarını kanıtla',
        description:
          'Aile birleşimi yoluyla oturma izni almak ve akrabalarım, eşim veya partnerimle taşınmak istiyorum.',
        icon: '/images/icons/family-ties.svg',
        userAnswer: 'Prove family ties',
      },
    ],
  },
  es: {
    answers: [
      {
        id: 'regular-income',
        title: 'Confirme ingresos regulares',
        description:
          'Gano 2000 € al mes y trabajo de forma remota. Planeo mudarme al extranjero como nómada digital.',
        icon: '/images/icons/regular-income.svg',
        userAnswer: 'Confirm regular income',
      },
      {
        id: 'family-ties',
        title: 'Demostrar vínculos familiares',
        description:
          'Quiero obtener un permiso de residencia a través de la reagrupación familiar y mudarme a vivir con familiares, cónyuge o pareja.',
        icon: '/images/icons/family-ties.svg',
        userAnswer: 'Prove family ties',
      },
    ],
  },
};

export const thankYouFinancialIndependentPageDict = {
  ru: {
    answers: [
      {
        id: 'passive-income',
        title: 'Подтвердить пассивный доход или сбережения',
        description:
          'Получаю пассивный доход, например в виде дивидендов или пенсии. Не планирую работать или вести бизнес в стране.',
        icon: '/images/icons/passive-income.svg',
        userAnswer: 'Confirm passive income or savings',
      },
      {
        id: 'univercity',
        title: 'Поступить в ВУЗ',
        description: 'Поступаю в ВУЗ и хочу получить ВНЖ на время обучения. ',
        icon: '/images/icons/univercity.svg',
        userAnswer: 'Enroll in a university',
      },
    ],
  },
  en: {
    answers: [
      {
        id: 'passive-income',
        title: 'Confirm passive income or savings',
        description:
          'I receive passive income, such as dividends or a pension. I do not plan to work or conduct business in the country.',
        icon: '/images/icons/passive-income.svg',
        userAnswer: 'Confirm passive income or savings',
      },
      {
        id: 'univercity',
        title: 'Enroll in a university',
        description:
          'I am enrolling in a university and want to obtain a residence permit for the duration of my studies.',
        icon: '/images/icons/univercity.svg',
        userAnswer: 'Enroll in a university',
      },
    ],
  },
  de: {
    answers: [
      {
        id: 'passive-income',
        title: 'Passives Einkommen oder Ersparnisse bestätigen',
        description:
          'Ich erhalte passives Einkommen, wie Dividenden oder eine Rente. Ich plane nicht, im Land zu arbeiten oder ein Geschäft zu betreiben.',
        icon: '/images/icons/passive-income.svg',
        userAnswer: 'Confirm passive income or savings',
      },
      {
        id: 'univercity',
        title: 'An einer Universität einschreiben',
        description:
          'Ich schreibe mich an einer Universität ein und möchte für die Dauer meines Studiums eine Aufenthaltsgenehmigung erhalten.',
        icon: '/images/icons/univercity.svg',
        userAnswer: 'Enroll in a university',
      },
    ],
  },
  tr: {
    answers: [
      {
        id: 'passive-income',
        title: 'Pasif gelir veya birikim onaylayın',
        description:
          'Pasif gelir elde ediyorum, örneğin temettüler veya emeklilik maaşı gibi. Ülkede çalışmayı veya iş yapmayı planlamıyorum.',
        icon: '/images/icons/passive-income.svg',
        userAnswer: 'Confirm passive income or savings',
      },
      {
        id: 'univercity',
        title: 'Üniversiteye kayıt olun',
        description:
          'Bir üniversiteye kaydoluyorum ve eğitim sürem boyunca oturma izni almak istiyorum.',
        icon: '/images/icons/univercity.svg',
        userAnswer: 'Enroll in a university',
      },
    ],
  },
  es: {
    answers: [
      {
        id: 'passive-income',
        title: 'Confirme ingresos pasivos o ahorros',
        description:
          'Recibo ingresos pasivos, como dividendos o una pensión. No planeo trabajar ni hacer negocios en el país.',
        icon: '/images/icons/passive-income.svg',
        userAnswer: 'Confirm passive income or savings',
      },
      {
        id: 'univercity',
        title: 'Inscribirse en una universidad',
        description:
          'Me estoy inscribiendo en una universidad y quiero obtener un permiso de residencia por la duración de mis estudios.',
        icon: '/images/icons/univercity.svg',
        userAnswer: 'Enroll in a university',
      },
    ],
  },
};

export const thankYouOrderPage2Dict = {
  ru: {
    confirmEmail:
      'Чтобы получить гайд, нужно подтвердить, что почта {email} принадлежит вам',
    title: 'Спасибо за ваш запрос - Immigrant Invest',
    description: '',
  },
  de: {
    confirmEmail:
      'Um den Leitfaden zu erhalten, müssen Sie Ihre E-Mail-Adresse {email} bestätigen',
    title: 'Vielen Dank für Ihre Anfrage! - Immigrant Invest',
    description: '',
  },
  en: {
    confirmEmail:
      'To get the guide, you need to confirm your email address {email}',
    title: 'Thank you for you request! - Immigrant Invest',
    description: '',
  },
  tr: {
    confirmEmail:
      'Rehberi almak için {email} e-posta adresinizi doğrulamanız gerekiyor',
    title: 'Başvurunuz için teşekkür ederiz! - Immigrant Invest',
    description: '',
  },
};

export const thankYouPricePage2Dict = {
  ru: {
    confirmEmail:
      'Чтобы получить расчёт стоимости, нужно подтвердить, что почта {email} принадлежит вам',
    title: 'Спасибо за ваш запрос - Immigrant Invest',
    description: '',
  },
  de: {
    confirmEmail:
      'Um eine Kosteneinschätzung zu erhalten, müssen Sie Ihre E-Mail-Adresse {email} bestätigen',
    title: 'Vielen Dank für Ihre Anfrage! - Immigrant Invest',
    description: '',
  },
  en: {
    confirmEmail:
      'To get a cost estimate, you need to confirm your email address {email}',
    title: 'Thank you for you request! - Immigrant Invest',
    description: '',
  },
  tr: {
    confirmEmail:
      'Fiyat tahmini almak için {email} e-posta adresinizi doğrulamanız gerekiyor',
    title: 'Başvurunuz için teşekkür ederiz! - Immigrant Invest',
    description: '',
  },
};

export const thankYouContactPageDict = {
  ru: {
    title: 'Спасибо за запрос контакты - Immigrant Invest',
    description: '',
    cardTitle: 'Ваш запрос успешно отправлен',
    cardDescription: 'Мы ответим на него в ближайшее время.',
  },
  en: {
    title: 'Thank you for your request contact - Immigrant Invest',
    description: '',
    cardTitle: 'Your inquiry has been sent successfully',
    cardDescription: 'We will reply you soon.',
  },
  de: {
    title: 'Vielen Dank für Ihre Anfrage. Kontakte – Immigrant Invest',
    description: '',
    cardTitle: 'Ihre Anfrage wurde erfolgreich versendet',
    cardDescription: 'Wir werden Ihnen bald antworten.',
  },
  tr: {
    title: 'Başvurunuz için teşekkür ederiz - Immigrant Invest',
    description: '',
    cardTitle: 'Başvurunuz başarıyla gönderildi',
    cardDescription: 'En kısa sürede size yanıt vereceğiz.',
  },
  es: {
    title: 'Gracias por su solicitud de contacto - Immigrant Invest',
    description: '',
    cardTitle: 'Su consulta ha sido enviada con éxito',
    cardDescription: 'Le responderemos pronto.',
  },
};

export const sorryPageDict = {
  en: {
    title: 'The site is closed for maintenance :(',
    description: 'Thank you for staying with us!',
  },
  ru: {
    title: 'Сайт закрыт на техническое обслуживание :(',
    description: 'Спасибо, что остаетесь с нами!',
  },
  de: {
    title: 'Ich schließe mich der technischen Verantwortung an :(',
    description: 'Vielen Dank, dass Sie bei uns geblieben sind!',
  },
  tr: {
    title: 'Site bakımda :(',
    description: 'Bizimle kaldığınız için teşekkür ederiz!',
  },
  es: {
    title: 'El sitio está cerrado por mantenimiento :(',
    description: '¡Gracias por quedarte con nosotros!',
  },
};

export const thankYouKysPageDict = {
  en: {
    title: 'Thank you! - Immigrant Invest',
    description: '',
    heading: 'Thank you!',
    subheading:
      '<p>Your form has been successfully received and is currently under review. We make every effort to ensure the process is swift and efficient. We will definitely respond and inform you of the outcome once the review is complete.</p> <p>Should you have any questions in the meantime, please feel free to reach out to our Investment Program Expert, who is ready to assist you.</p>',
  },
  ru: {
    title: 'Спасибо! - Immigrant Invest',
    description: '',
    heading: 'Спасибо!',
    subheading:
      '<p>Ваша форма успешно получена и находится на стадии рассмотрения. Мы прилагаем все усилия, чтобы процесс прошел быстро и эффективно. Мы обязательно ответим вам и сообщим о результате после завершения проверки.</p> <p>Если у вас возникнут вопросы в процессе ожидания, не стесняйтесь обращаться к эксперту  инвестиционных программам, который рад вам помочь.</p>',
  },
  tr: {
    title: 'Teşekkürler! - Immigrant Invest',
    description: '',
    heading: 'Teşekkürler!',
    subheading:
      '<p>Formunuz başarıyla alınmıştır ve şu anda incelenmektedir. Sürecin hızlı ve verimli olmasını sağlamak için elimizden geleni yapıyoruz. İnceleme tamamlandığında mutlaka size geri dönecek ve sonucu bildireceğiz.</p> <p>Bu arada herhangi bir sorunuz olursa, size yardımcı olmaktan memnuniyet duyacak olan Yatırım Programı Uzmanımıza ulaşmaktan çekinmeyin.</p>',
  },
  de: {
    title: 'Vielen Dank! - Immigrant Invest',
    description: '',
    heading: 'Vielen Dank!',
    subheading:
      '<p>Ihr Formular wurde erfolgreich erhalten und wird derzeit überprüft. Wir tun unser Bestes, um den Prozess schnell und effizient zu gestalten. Sobald die Überprüfung abgeschlossen ist, werden wir Ihnen antworten und Sie über das Ergebnis informieren.</p> <p>Sollten Sie in der Zwischenzeit Fragen haben, zögern Sie bitte nicht, sich an unseren Experten für Investitionsprogramme zu wenden, der Ihnen gerne weiterhilft.</p>',
  },
  es: {
    title: '¡Gracias! - Immigrant Invest',
    description: '',
    heading: '¡Gracias!',
    subheading:
      '<p>Su formulario ha sido recibido con éxito y actualmente está siendo revisado. Hacemos todo lo posible para que el proceso sea rápido y eficiente. Una vez que se complete la revisión, definitivamente le responderemos e informaremos el resultado.</p> <p>Si tiene alguna pregunta mientras tanto, no dude en comunicarse con nuestro Experto en Programas de Inversión, quien estará encantado de ayudarle.</p>',
  },
};
